export default {"src":"/_next/static/media/project_creation.a566b71a.svg","height":647,"width":1411,"blurWidth":0,"blurHeight":0};